export const defaultValues = {
	phone: '+79654940182',
	password: '12345678',
}
